<app-homepage-header pageName="Cart"></app-homepage-header>
@if (loading){
  <div class="d-flex justify-content-center mt-10 mb-10 flex-direction-row gap-10px">
    <mat-spinner mode="indeterminate" [diameter]="60"></mat-spinner>   </div>
} @else {
  <div>
    @if (!shoppingCart || shoppingCart?.items?.length == 0) {
      <app-cart-empty></app-cart-empty>
    } @else {
      <div class="w-100 h-100 mt-100px cart-huge">
        <div class="w-100 h-100 cart-main">

          <div class="cart-info w-100 h-100">

            <div class="product-list w-100">
              <div class="cart-products h-100 w-100">
                <div class="cart-main-section">
                  <span class="cms-long">{{'cart.product' | translate}}</span>
                  <span class="cms-short">{{'cart.color' | translate}}</span>
                  <span class="cms-short2">{{'cart.quantity' | translate}}</span>
                  <span class="cms-short csh-unique">{{'cart.price' | translate}}</span>
                </div>
                @if (shoppingCart?.items != undefined) {

                  @for (cart of shoppingCart.items; track cart) {
                    <div class="cart-section w-100">
                      <div class="cs-product">
                        <div class="cs-product-img">
                          <img [src]="getProductImageUrl(cart.product.imageUrls[0])" alt="Product picture"
                               class="cs-product-img-small">
                        </div>
                        <span class="cs-product-name">
                  {{ cart.product.productName }}
            </span>
                      </div>
                      <div class="cs-product-mob not-visible">
                        <div class="cs-product-mob-central">
                          <div class="cs-product-mob-central-product">
                            <img [src]="getProductImageUrl(cart.product.imageUrls[0])" alt="Product picture"
                                 class="cpm-img">
                          </div>
                          <div class="cs-product-mob-central-frame">
                            <div class="cs-product-mob-central-frame-f1">
                              <div class="small-frame1">
                                @if (cart.attributeValues.length > 0) {
                                  <label
                                    [style.background-color]="cart.attributeValues[0].value"
                                    class="color-ellipse-mob flex-visible">
                                  </label>
                                }
                                <span class="mob-text flex-visible">{{ cart.product.productName }}</span>
                              </div>
                              <div class="mob-price-qty-row">
                                <span class="small-frame2">
                                  ${{ getTotalPriceUSD(cart) | number:'1.1-1' }}/{{ cart.product.price * cart.quantity }}
                                  <span class="mob-currency">{{ ' ' + ('subscription_plan_content.AMD' | translate) }}</span>
                                </span>
                                <div class="cs-product-mob-central-frame-f2">
                                  <div class="cs-central-calc">
                                    <span class="cs-frame-count">{{ cart.quantity }}</span>
                                    <div class="cs-qty-frame-navi">
                                      <div (click)="increaseProductQuantity(cart)"
                                           [ngClass]="{'drop-up-small-nav': cart.quantity >= 1, 'drop-up-small-disabled-nav': cart.quantity < 1 }">
                                      </div>
                                      <div (click)="reduceProductQuantity(cart)"
                                           [ngClass]="{'drop-down-small-nav': cart.quantity > 1, 'drop-down-small-disabled-nav': cart.quantity <=1 }">
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <span class="remove-mob" (click)="onRemoveItem(cart.id)">{{'cart.remove' | translate}}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="cs-price">

                        @if (cart.attributeValues.length > 0) {
                          <label
                            [style.background-color]="cart.attributeValues[0].value"
                            class="color-ellipse">
                          </label>
                        }
                      </div>
                      <div class="cs-qty">
                        <div class="cs-qty-middle">
                          <div class="cs-qty-frame">
                            <span class="cs-qty-frame-count">{{ cart.quantity }}</span>
                            <div class="cs-qty-frame-navigator">
                              <div (click)="increaseProductQuantity(cart)"
                                   [ngClass]="{'drop-up-small': cart.quantity >= 1, 'drop-up-small-disabled': cart.quantity < 1}">
                              </div>
                              <div (click)="reduceProductQuantity(cart)"
                                   [ngClass]="{'drop-down-small': cart.quantity >1, 'drop-down-small-disabled': cart.quantity <= 1}">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="cs-subtotal">
                <span class="cs-subtotal-price">
                  ${{ getTotalPriceUSD(cart) | number:'1.1-1' }} /{{ cart.product.price * cart.quantity }}
                  <span style="font-size: 14px;!important;"
                        class="ms-1">{{ ' ' + ('subscription_plan_content.AMD' | translate) }}</span>
                </span>
                        <span class="cs-subtotal-remove" (click)="onRemoveItem(cart.id)">{{'cart.remove' | translate}}</span>
                      </div>
                    </div>
                  }
                }
              </div>
            </div>

            <div class="cart-total">
              <div class="ct-content w-100">
                <h2 class="ct-content-title">{{'cart.cart_total' | translate}}</h2>
                <mat-divider></mat-divider>
                <div class="d-flex justify-content-between">
                  <div class="text-muted">{{'cart.total' | translate }}</div>
                  @if (shoppingCart) {
                    <div>${{ (shoppingCart.totalAmount / currencyRate)| number:'1.1-1'}}/{{ shoppingCart.totalAmount }}<span
                      class="fs-14 ms-1">{{ 'subscription_plan_content.AMD' | translate }}</span></div>
                  }
                </div>
                <mat-divider></mat-divider>
              </div>
              <div class="ct-action w-100">
                <button class="ct-action-checkout w-100" (click)="checkout()">
                  <span class="ct-action-checkout-text">{{'cart.checkout' | translate }}</span>
                </button>
                <button class="ct-action-return w-100" [routerLink]="['/products']">
                  <span class="ct-action-return-text">{{'cart.return_to_shop' | translate }}</span>
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    }
  </div>
}

<app-footer></app-footer>
